// src/features/rate-limit/rateLimitSlice.ts
// Не персистится намеренно (persist whitelist-based): перезагрузка = новая попытка.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface RateLimitState {
  isBanned: boolean
}

const initialState: RateLimitState = {
  isBanned: false,
}

const rateLimitSlice = createSlice({
  name: 'rateLimit',
  initialState,
  reducers: {
    setRateLimitBanned: (state, action: PayloadAction<boolean>) => {
      state.isBanned = action.payload
    },
  },
})

export const { setRateLimitBanned } = rateLimitSlice.actions
export const rateLimitReducer = rateLimitSlice.reducer
